import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, Validators, FormGroup, FormControl, FormArray } from '@angular/forms';
import { IsActiveMatchOptions, NavigationExtras, Router } from '@angular/router';
import { ControlInfra } from '@page/connect-bank-account/helper/connect-bank-types';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as _ from 'lodash';
import { throwError } from 'rxjs';
// import jsPDF from 'jspdf';
@Injectable({
    providedIn: 'root'
})
export class SprintNextUtilService {

    convertNumberToWords(amount: any) {
        var words = new Array();
        words[0] = '';
        words[1] = 'One';
        words[2] = 'Two';
        words[3] = 'Three';
        words[4] = 'Four';
        words[5] = 'Five';
        words[6] = 'Six';
        words[7] = 'Seven';
        words[8] = 'Eight';
        words[9] = 'Nine';
        words[10] = 'Ten';
        words[11] = 'Eleven';
        words[12] = 'Twelve';
        words[13] = 'Thirteen';
        words[14] = 'Fourteen';
        words[15] = 'Fifteen';
        words[16] = 'Sixteen';
        words[17] = 'Seventeen';
        words[18] = 'Eighteen';
        words[19] = 'Nineteen';
        words[20] = 'Twenty';
        words[30] = 'Thirty';
        words[40] = 'Forty';
        words[50] = 'Fifty';
        words[60] = 'Sixty';
        words[70] = 'Seventy';
        words[80] = 'Eighty';
        words[90] = 'Ninety';
        amount = amount.toString();
        var atemp = amount.split('.');
        var number = atemp[0].split(',').join('');
        var n_length = number.length;
        var words_string = '';
        if (n_length <= 9) {
            var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
            var received_n_array = new Array();
            for (var i = 0; i < n_length; i++) {
                received_n_array[i] = number.substr(i, 1);
            }
            for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
                n_array[i] = received_n_array[j];
            }
            for (var i = 0, j = 1; i < 9; i++, j++) {
                if (i == 0 || i == 2 || i == 4 || i == 7) {
                    if (n_array[i] == 1) {
                        n_array[j] = 10 + parseInt(n_array[j] as any);
                        n_array[i] = 0;
                    }
                }
            }
            let value;
            for (var i = 0; i < 9; i++) {
                if (i == 0 || i == 2 || i == 4 || i == 7) {
                    value = n_array[i] * 10;
                } else {
                    value = n_array[i];
                }
                if (value != 0) {
                    words_string += words[value] + ' ';
                }
                if (
                    (i == 1 && value != 0) ||
                    (i == 0 && value != 0 && n_array[i + 1] == 0)
                ) {
                    words_string += 'Crores ';
                }
                if (
                    (i == 3 && value != 0) ||
                    (i == 2 && value != 0 && n_array[i + 1] == 0)
                ) {
                    words_string += 'Lakhs ';
                }
                if (
                    (i == 5 && value != 0) ||
                    (i == 4 && value != 0 && n_array[i + 1] == 0)
                ) {
                    words_string += 'Thousand ';
                }
                if (
                    i == 6 &&
                    value != 0 &&
                    n_array[i + 1] != 0 &&
                    n_array[i + 2] != 0
                ) {
                    words_string += 'Hundred and ';
                } else if (i == 6 && value != 0) {
                    words_string += 'Hundred ';
                }
            }
            words_string = words_string.split('  ').join(' ');
        }
        return words_string;
    }

    monthNames: string[] = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    /**
     * Constructor
     */
    constructor(
        private datepipe: DatePipe,
        private _Router: Router
    ) { }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the equivalent "IsActiveMatchOptions" options for "exact = true".
     */
    get exactMatchOptions(): IsActiveMatchOptions {
        return {
            paths: 'exact',
            fragment: 'ignored',
            matrixParams: 'ignored',
            queryParams: 'exact'
        };
    }

    /**
     * Get the equivalent "IsActiveMatchOptions" options for "exact = false".
     */
    get subsetMatchOptions(): IsActiveMatchOptions {
        return {
            paths: 'subset',
            fragment: 'ignored',
            matrixParams: 'ignored',
            queryParams: 'subset'
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Generates a random id
     *
     * @param length
     */

    highest_z_indexFn(getList: boolean = false) {
        var highest_z_index = 0;
        var current_z_index = 0;
        let zindexList: any = [];
        // Loop through each div and get the highest z-index
        $(':root *').each(function () {
            current_z_index = parseInt($(this).css('z-index'));

            if (current_z_index > highest_z_index) {
                highest_z_index = current_z_index + 1;
                zindexList.push(current_z_index);
            }
        });
        if (getList) {
            return zindexList;
        }
        return highest_z_index;
    }

    set_Z_index(ele: any, plus: number) {
        let zindexlgth = this.highest_z_indexFn(true);
        if (zindexlgth.length > 1) {
            let setZinx = zindexlgth[zindexlgth.length - 2];
            $(ele).css('z-index', setZinx + plus);
        }
    }
    randomId(length: number = 10): string {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let name = '';

        for (let i = 0; i < 10; i++) {
            name += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        return name;
    }

    setFormData(dataList: { [ket: string]: any } | any[]) {
        if (!dataList) {
            return throwError(() => new Error('Not a valid Data.'));
        }
        let formData: FormData = new FormData();
        if (Array.isArray(dataList)) {
            dataList.forEach((i: any) => {

            })
        } else {
            this.updateFormData(formData, dataList);
        }
        return formData;
    }

    updateFormData(formData: FormData, dataList: { [ket: string]: any }) {
        if (!(formData || dataList)) {
            return throwError(() => new Error('Not a valid Data.'));
        }
        for (const key in dataList) {
            if (Object.prototype.hasOwnProperty.call(dataList, key)) {
                formData.append(key, dataList[key]);
            }
        }
        return formData;
    }

    consoleFormData(formData: FormData) {
        for (var pair of (formData as any).entries()) {
            console.log(`${pair[0]} typeof ${typeof pair[1]} ${pair[1]}`);
        }
    }

    filterArray(data: any, value: string): any[] {
        return _.filter(data, (o) => _.includes(o, value));
    }

    // date transformation
    getTransformDate(date: any, format: any = 'yyyy/MM/dd') {
        // console.log(date, format);
        let afterformat = this.datepipe.transform(date, format);
        // console.log('afterformat- ', afterformat);

        return afterformat;
    };

    getTodayDate(): {
        'day': string;
        'month': string;
        'year': string;
    } {
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        let yyyy = today.getFullYear();
        // console.log({
        //     'day': dd,
        //     'month': mm,
        //     'year': yyyy.toString()
        // });

        return {
            'day': dd,
            'month': mm,
            'year': yyyy.toString()
        };
    }
    /**
        * Get value from infinite level object.
        * @param value An object from gey key value.
        * @param key A key used to get value from object.
        */
    getvalueFromKey(value: any, key: string) {
        if (key.indexOf('.') !== -1) {
            let arr: any = key.split('.');
            var k: any = 'value';

            arr.forEach((element: any) => {
                k += '[';
                k += "'" + element + "'";
                k += ']';
            });
            return eval(k);
            // this.TestClass.Run.call(this, k);
        }
        if (key) {
            return value[key];
        }
        return null;
    }

    generatePDF(
        invoiceElement: any,
        filename: any,
        isType: 'PRINT' | 'DOWNLOAD' = 'DOWNLOAD',
        customPage?: boolean
    ): void {
        // let invoiceElement: any = { _invoiceElement };
        // invoiceElement = invoiceElement._invoiceElement;
        html2canvas(invoiceElement, {
            scale: 3, onclone(document: Document, element: HTMLElement) {
                element.querySelector('.receiptStampBox')?.classList.remove('d-none')
            },
        }).then((canvas) => {
            // console.log(canvas);

            const imageGeneratedFromTemplate = canvas.toDataURL('image/png');

            const fileWidth = 200;
            const generatedImageHeight = (canvas.height * fileWidth) / canvas.width;
            let page: any = 'a4'
            if (customPage) {
                page = [fileWidth + 20, generatedImageHeight]
            }
            let PDF = new jsPDF('p', 'mm', page);
            PDF.addImage(
                imageGeneratedFromTemplate,
                'PNG',
                5,
                5,
                fileWidth,
                generatedImageHeight,
                '',
                'MEDIUM'
            );
            PDF.rect(
                5,
                5,
                PDF.internal.pageSize.width - 10,
                PDF.internal.pageSize.height - 10,
                'S'
            );
            // invoiceElement.querySelector('.receiptStampBox')?.classList.remove('d-none');
            // console.log(invoiceElement.querySelector('.receiptStampBox'));

            PDF.html(invoiceElement.innerHTML);
            if (isType == 'DOWNLOAD') {
                PDF.save(`${filename}.pdf`);
            } else if (isType == 'PRINT') {
                PDF.autoPrint();
                window.open(PDF.output('bloburl'), '_blank');
            }
        });
    }
    generateImage(_invoiceElement: any, filename: any,) {
        html2canvas(_invoiceElement, {
            backgroundColor: 'transparent',
            scale: 3, onclone(document: Document, element: HTMLElement) {
                element.querySelector('.receiptStampBox')?.classList.remove('d-none')
            },
        }).then(canvas => {
            const imageGeneratedFromTemplate = canvas.toDataURL('image/png');
            var a = document.createElement('a');
            a.href = imageGeneratedFromTemplate;
            a.download = filename + '.png';
            a.click();
        });
    }

    capitalizeFirstLetter(string: string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    maskString(string: string, size: number) {
        return size < string.length ?                     // if string is longer than size
            "X".repeat(size) + string.substring(size) : // ... replace the part
            "X".repeat(string.length);                // ... or replace the whole
    }

    resetComponent(url: any = this._Router.url, extras: Partial<NavigationExtras> | undefined = undefined) {
        console.log(url);
        console.log(extras);

        setTimeout(() => {
            this._Router.navigateByUrl('/', { skipLocationChange: true }).then(() => {

                this._Router.navigate([url], extras);
            });
        }, 1);
    }

    getDeepCopy(obj: any) {

        if (obj.constructor === Array) {
            return _.merge([], obj);
        }
        return _.merge({}, obj);
    }

    getVariableType(object: any): 'Object' | 'Array' | 'String' | 'Number' | 'Boolean' | 'Null' | 'RegExp' | 'Undefined' { return (object.__proto__.constructor.name); }

    convertMinsToHrsMins(mins: number): {
        h: string, m: string
    } {
        let h: any = Math.floor(mins / 60);
        let m: any = mins % 60;
        h = h < 10 ? '0' + h : h; // (or alternatively) h = String(h).padStart(2, '0')
        m = m < 10 ? '0' + m : m; // (or alternatively) m = String(m).padStart(2, '0')
        return {
            h, m
        }
    }

    initDynamicForm(formData: ControlInfra[], _dynamicForm: FormArray) {
        _dynamicForm.clear();
        // console.log(formData);

        formData.forEach((e: ControlInfra) => {
            let validation: ((control: AbstractControl<any, any>) => ValidationErrors | null)[] = []

            if (e.required === "Y") {
                validation.push(Validators.required);
            }
            if (e.minLength) {
                validation.push(Validators.minLength(e.minLength));
            }
            if (e.maxLength) {
                validation.push(Validators.maxLength(e.maxLength));
            }

            let control: FormGroup = new FormGroup({
                // [e.fieldname]: new FormControl(null, validation)
                [e.fieldname]: new FormControl(e?.value ?? '', validation)
            });
            if (e.type === 'file') {


                control.addControl('fileData', new FormControl<File | null>(e?.value ?? '', validation));

                control.get('fileData')?.valueChanges.subscribe((v: any) => {
                    // console.log(v);
                    // console.log(e);

                    control.get(e.fieldname)?.setValue((v?.url ?? ''));
                })
                control.updateValueAndValidity();

            }
            if (e.type === 'checkbox') {
                let mainControl: FormControl = control.get(e.fieldname) as FormControl;
                let checkBoxGroup: FormGroup = new FormGroup({});
                e.options?.forEach((e) => {
                    checkBoxGroup.addControl((e.value).toString(), new FormControl(false));
                })
                control.addControl('checkBoxGroup', checkBoxGroup);
                checkBoxGroup.valueChanges.subscribe((v: { [key: string]: any }) => {

                    const returnType: any = 'pipeSeparated';
                    // const returnType: 'array' | 'pipeSeparated' = 'pipeSeparated';
                    let dyVal: any = returnType === 'pipeSeparated' ? '' : [];

                    for (const [key, value] of Object.entries(v)) {
                        if (key != e.fieldname && value) {
                            if (returnType === 'pipeSeparated') {
                                dyVal += key + '|';
                            } else
                                if (returnType === 'array') {
                                    dyVal.push(key);
                                }
                        }
                    }
                    if (returnType === 'pipeSeparated') {
                        dyVal = dyVal.slice(0, -1);
                    }

                    mainControl?.setValue(dyVal.length > 0 ? dyVal : null);
                    mainControl.markAsTouched();
                    // mainControl.markAsDirty();
                })
                control.updateValueAndValidity();
            }

            _dynamicForm.push(control);
        })

    }
    generateRandomAlphanumeric(length: number = 12): string {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let result = '';
 
        // Generate random characters
        for (let i = 0; i < length - 4; i++) { // Reserve 4 characters for timestamp
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
 
        // Append timestamp (last 4 digits for uniqueness)
        const timestamp = Date.now().toString().slice(-4);
 
        return result + timestamp;
  }
}
